module.exports = __webpack_public_path__ + "img/case10-中石化.78326725.png";